import { object, string, boolean } from "yup";
import i18n from "i18n";

export const editRestaurantValidate = object().shape({
  name: string().trim().required(i18n.t("errors.required")),
  address: string().trim().required(i18n.t("errors.required")),
  phone: string(),
  thumbnail: object().nullable().required(i18n.t("errors.required")),
  hasPromotion: boolean().required(i18n.t("errors.required")),
  discountCondition: string()
    .nullable()
    .when("hasPromotion", {
      is: true,
      then: (schema) => schema.required(i18n.t("errors.required")),
      otherwise: (schema) => schema.notRequired(),
    }),
  discountPercentage: string()
    .nullable()
    .when("hasPromotion", {
      is: true,
      then: (schema) => schema.required(i18n.t("errors.required")),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export const createRestaurantValidate = editRestaurantValidate.shape({
  banners: object().nullable().required(i18n.t("errors.required")),
});
